module.exports = __webpack_public_path__ + "img/mob.3f05aff1.svg";